"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStackTrace = void 0;
const tslib_1 = require("tslib");
const first_1 = tslib_1.__importDefault(require("lodash/first"));
const toString_1 = tslib_1.__importDefault(require("lodash/toString"));
const sourcemapped_stacktrace_1 = require("sourcemapped-stacktrace");
async function getStackTrace(error) {
    const stacktrace = new Promise((resolve) => (0, sourcemapped_stacktrace_1.mapStackTrace)(error.stack, (mappedStack) => resolve([(0, toString_1.default)(error), mappedStack.join("\n")].join("\n"))));
    return await stacktrace;
}
exports.getStackTrace = getStackTrace;
async function serialize(...messages) {
    const stacktraces = [];
    const variables = [];
    const message = await Promise.all(messages.map(async (msg) => {
        if (msg === undefined || msg === null) {
            return String(msg);
        }
        else if (["object", "function"].indexOf(typeof msg) !== -1) {
            if (msg instanceof Error) {
                const errorName = `error${variables.length + 1}`;
                const errorValue = (0, toString_1.default)(msg);
                const stacktrace = await getStackTrace(msg);
                stacktraces.push(stacktrace);
                variables.push({ [errorName]: stacktrace });
                // Errors are short and straight forward, and wont be complex when cast to string,
                // so represent them with their real value, e.g <TypeError: This is not allowed>
                return `<${errorValue}>`;
            }
            // For non-error objects, naming is variable1, variable2, etc
            const variableName = `variable${variables.length + 1}`;
            const variableValue = typeof msg === "function" ? (0, toString_1.default)(msg) : JSON.stringify(msg);
            variables.push({ [variableName]: variableValue });
            // For most variables, substitute the variable with <variable1> or <variable2>
            // and represent them in context.
            return `<${variableName}>`;
        }
        return String(msg);
    }));
    return {
        clientBrowser: navigator.userAgent,
        context: Object.assign({}, ...variables),
        message: message.join(" "),
        stacktrace: (0, first_1.default)(stacktraces),
        timestamp: new Date().getTime(),
    };
}
exports.default = serialize;
